export class CanadaPostAddress {
  Id: string;
  Text: string;
  Description: string;
}
